/* eslint-disable spire/export-styles */
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CategoryDetailsPageContext } from "@insite/content-library/Pages/CategoryDetailsPage";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;



const CategoryName = ({ category, currentPage }: Props) => {
    if (!category) {
        return null;
    }
    const styles = {
        categoryStyleNew: {
            css: css`
                color: #002554;
                font-family: 'Roboto',sans-serif;
                
                font-size: 1.5rem;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 1.75rem;

                div {
                    font-size: .625rem;
                    line-height: .625rem;
                }

                @media screen and (min-width: 990px) and (max-width: 1399px) {
                    padding-left: .625rem;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                            font-size: 1.3125rem;
                            line-height: 1.5rem;
                        `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )};
            `,
        }
    };

    return (
        <Typography {...styles.categoryStyleNew} as="h1">
            {category.shortDescription}
            <Typography as="div" >
                <svg width="20" height="3" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 3V0h20v3z" fill="#C63527" fillRule="nonzero"></path>
                </svg>
            </Typography>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Categories",
        icon: "PageTitle",
        allowedContexts: [CategoryDetailsPageContext, ProductDetailsPageContext, ProductListPageContext],
    },
};

export default widgetModule;
